import React from 'react';
import { useCallback, useState } from 'react';
import { MESSAGE_ACCOUNT_DELETED_SUCCESSFULLY, MESSAGE_MUST_COMPLETE_ACCOUNT_SETUP_FIRST } from '../constants';
import AfitdMessageDialog from '../elemental/AfitdMessageDialog';
// import _get from 'lodash/get';

const useMessageDialog = ({ onClose, message = '' } = {}) => {
    const [open, setOpen] = useState(false);

    const handleCloseDialog = useCallback(() => {
        setOpen(false);
        if (onClose) onClose();
    }, [setOpen, onClose]);

    const dialogProps = { open, onClose: handleCloseDialog, message };

    const MessageDialog = props => {
        return <AfitdMessageDialog {...dialogProps} {...props} />;
    };

    const PendingAccountSetupMessageDialog = props => {
        return <AfitdMessageDialog {...dialogProps} {...props} message={MESSAGE_MUST_COMPLETE_ACCOUNT_SETUP_FIRST} />;
    };

    const DeleteAccountSuccessfulMessageDialog = props => {
        return <AfitdMessageDialog {...dialogProps} {...props} message={MESSAGE_ACCOUNT_DELETED_SUCCESSFULLY} />;
    };

    return { open, setOpen, handleCloseDialog, dialogProps, MessageDialog, PendingAccountSetupMessageDialog, DeleteAccountSuccessfulMessageDialog };
};

export default useMessageDialog;
